import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { putContentsRatingCall } from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [putContentsRatingCall.saga];

export function* trainingContentsRatingRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
